export const COMPANY_NAMES: Record<string, string> = {
  MSFT: 'Microsoft Corporation',
  GOOGL: 'Alphabet Inc.',
  META: 'Meta Platforms, Inc.',
  NVDA: 'NVIDIA Corporation',
  TSLA: 'Tesla, Inc.',
  NFLX: 'Netflix, Inc.',
  CSCO: 'Cisco Systems, Inc.',
  INTC: 'Intel Corporation',
  ORCL: 'Oracle Corporation',
  IBM: 'International Business Machines Corporation',
  SAP: 'SAP SE',
  AAPL: 'Apple Inc.',
  AMZN: 'Amazon.com, Inc.',
  HPQ: 'HP Inc.',
  CRM: 'Salesforce, Inc.',
  VEEV: 'Veeva Systems Inc.',
  ADBE: 'Adobe Inc.',
  SNOW: 'Snowflake Inc.',
  DDOG: 'Datadog, Inc.',
  NOW: 'ServiceNow, Inc.',
  TEAM: 'Atlassian Corporation',
  ZS: 'Zscaler, Inc.',
  CRWD: 'CrowdStrike Holdings, Inc.',
  OKTA: 'Okta, Inc.',
  PANW: 'Palo Alto Networks, Inc.',
  ELF: 'e.l.f. Beauty, Inc.',
  BBY: 'Best Buy Co., Inc.',
  TGT: 'Target Corporation',
  WMT: 'Walmart Inc.',
  COST: 'Costco Wholesale Corporation',
  SBUX: 'Starbucks Corporation',
  MCD: "McDonald's Corporation",
  NKE: 'Nike, Inc.',
  DIS: 'The Walt Disney Company',
  CMG: 'Chipotle Mexican Grill, Inc.',
  LULU: 'Lululemon Athletica Inc.',
  ULTA: 'Ulta Beauty, Inc.',
  SBH: 'Sally Beauty Holdings, Inc.',
  JNJ: 'Johnson & Johnson',
  PFE: 'Pfizer Inc.',
  MRK: 'Merck & Co., Inc.',
  ABBV: 'AbbVie Inc.',
  UNH: 'UnitedHealth Group Incorporated',
  CVS: 'CVS Health Corporation',
  WBA: 'Walgreens Boots Alliance, Inc.',
  ABT: 'Abbott Laboratories',
  TMO: 'Thermo Fisher Scientific Inc.',
  DHR: 'Danaher Corporation',
  ISRG: 'Intuitive Surgical, Inc.',
  REGN: 'Regeneron Pharmaceuticals, Inc.',
  GILD: 'Gilead Sciences, Inc.',
  JPM: 'JPMorgan Chase & Co.',
  BAC: 'Bank of America Corporation',
  WFC: 'Wells Fargo & Company',
  GS: 'The Goldman Sachs Group, Inc.',
  MS: 'Morgan Stanley',
  V: 'Visa Inc.',
  MA: 'Mastercard Incorporated',
  AXP: 'American Express Company',
  BLK: 'BlackRock, Inc.',
  SCHW: 'The Charles Schwab Corporation',
  C: 'Citigroup Inc.',
  BA: 'The Boeing Company',
  GE: 'General Electric Company',
  CAT: 'Caterpillar Inc.',
  DE: 'Deere & Company',
  HON: 'Honeywell International Inc.',
  LMT: 'Lockheed Martin Corporation',
  RTX: 'Raytheon Technologies Corporation',
  UPS: 'United Parcel Service, Inc.',
  FDX: 'FedEx Corporation',
  XOM: 'Exxon Mobil Corporation',
  CVX: 'Chevron Corporation',
  COP: 'ConocoPhillips',
  SLB: 'Schlumberger Limited',
  EOG: 'EOG Resources, Inc.',
  PXD: 'Pioneer Natural Resources Company',
  NEM: 'Newmont Corporation',
  FCX: 'Freeport-McMoRan Inc.',
  BHP: 'BHP Group Limited',
  RIO: 'Rio Tinto Group',
  VALE: 'Vale S.A.',
  AMT: 'American Tower Corporation',
  PLD: 'Prologis, Inc.',
  CCI: 'Crown Castle Inc.',
  WELL: 'Welltower Inc.',
  EQR: 'Equity Residential',
  T: 'AT&T Inc.',
  VZ: 'Verizon Communications Inc.',
  TMUS: 'T-Mobile US, Inc.',
  CHTR: 'Charter Communications, Inc.',
  CMCSA: 'Comcast Corporation',
  NEE: 'NextEra Energy, Inc.',
  DUK: 'Duke Energy Corporation',
  SO: 'The Southern Company',
  D: 'Dominion Energy, Inc.',
  AEP: 'American Electric Power Company, Inc.',
  PG: 'Procter & Gamble Co.',
  KO: 'The Coca-Cola Company',
  PEP: 'PepsiCo, Inc.',
  // CL: 'Colgate-Palmolive Company',
  // KMB: 'Kimberly-Clark Corporation',
  // AMD: 'Advanced Micro Devices, Inc.',
  // QCOM: 'QUALCOMM Incorporated',
  // AVGO: 'Broadcom Inc.',
  // TXN: 'Texas Instruments Incorporated',
  // MU: 'Micron Technology, Inc.',
  // BIIB: 'Biogen Inc.',
  // VRTX: 'Vertex Pharmaceuticals Incorporated',
  // ALGN: 'Align Technology, Inc.',
  // DXCM: 'DexCom, Inc.',
  // IDXX: 'IDEXX Laboratories, Inc.',
  // YUM: 'Yum! Brands, Inc.',
  // MAR: 'Marriott International, Inc.',
  // AIG: 'American International Group, Inc.',
  // PRU: 'Prudential Financial, Inc.',
  // MET: 'MetLife, Inc.',
  // ALL: 'The Allstate Corporation',
  // PGR: 'The Progressive Corporation',
};
